
import { onClickOutside } from '@vueuse/core';
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  Ref,
  watch,
} from 'vue';
import { IError, IFolder } from '@/types/interfaces';
import DriveInput from '../modules/drive/components/UI/DriveInput.vue';
import AppLoader from './UI/AppLoader.vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import NotificationService from '@/services/NotificationService';

export default defineComponent({
  components: {
    DriveInput,
    AppLoader,
  },
  props: {
    folder: { type: Object as PropType<IFolder>, required: true },
    mountErrorInfo: { type: Object as PropType<{title: string, error: string}>, required: false },
  },
  emits: ['close', 'open', 'clearMountErrorInfo'],
  setup(props, { emit }) {
    const modal = ref();
    const driveStore = useDriveStore();

    const isLoader: Ref<boolean> = ref(false);

    const folderTitle = ref(props.folder.name);
    const error = ref('');

    const skipValidationClear = ref(false);

    const disabled = computed(() => !!error.value || !folderTitle.value);

    function close() {
      emit('close');
    }

    function setError(prevTitle: string, errorTitle: string) {
      folderTitle.value = prevTitle;
      error.value = errorTitle;
    }

    function renameFolder(): void {
      if (disabled.value) {
        return;
      }
      // isLoader.value = true;

      const title = folderTitle.value;

      driveStore.renameFolder(title, props.folder.id)
        .then((res) => {
          if (res.success) {
            // NotificationService.notifySuccess();
          } else {
            const errorData = res?.response?.data;
            if (errorData) {
              if (errorData.errorKey === 'FOLDER_NAME_EXISTS') {
                emit('open', { title, error: 'Name is already taken' });
              } else {
                emit('open', { title, error: 'Something gone wrong' });
              }
            }
          }
        });
      isLoader.value = false;
      close();
    }

    function inFolderNameUniq(): boolean {
      if (!driveStore.currentFolder) {
        return false;
      }
      return !!driveStore.currentFolder?.mixedData?.find((folder) => folder?.folder?.name === folderTitle.value);
    }

    watch(() => folderTitle.value, () => {
      if (!folderTitle.value) {
        error.value = 'This filed is required';
      } else if (folderTitle.value.length < 4) {
        error.value = 'Folder name must be at least 4 characters long.';
      } else if (folderTitle.value.length > 255) {
        error.value = 'Folder name must be max 255 characters long.';
      } else if (inFolderNameUniq()) {
        error.value = 'Name is already taken';
      } else if (!skipValidationClear.value) {
        error.value = '';
      } else {
        skipValidationClear.value = false;
      }
      folderTitle.value = folderTitle.value.replace(/(\r\n|\n|\r)/gm, '');
    });

    onClickOutside(modal, close);

    onMounted(() => {
      if (props.mountErrorInfo) {
        skipValidationClear.value = true;
        setError(props.mountErrorInfo.title, props.mountErrorInfo.error);
        emit('clearMountErrorInfo');
      }
    });

    return {
      modal,
      folderTitle,
      error,
      disabled,
      isLoader,
      close,
      renameFolder,
    };
  },
});
